module.exports = "../../app/cells/pages/landing_playground/index/tools_cell.rb";